const OrderDetailPoint = class {
  constructor({ usageAmount, expectedEarnAmount }) {
    this.usageAmount = usageAmount
    this.expectedEarnAmount = expectedEarnAmount
  }
}

export default null

export const ofOrderDetailPoint = (params = {}) => new OrderDetailPoint(params)
